import type { ReactNode } from 'react';
import { Box } from 'folds';
import type { UnreadCounts } from '$components/unread-badge';
import { UnreadBadge } from '$components/unread-badge';

const overlayAnchorStyle = {
  position: 'relative' as const,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

type SidebarUnreadBadgeProps = {
  children: ReactNode;
  unread?: UnreadCounts;
  count?: number;
  dm?: boolean;
};

export function SidebarUnreadBadge({
  children,
  unread,
  count,
  dm,
}: Readonly<SidebarUnreadBadgeProps>) {
  return (
    <Box style={overlayAnchorStyle}>
      {children}
      <UnreadBadge overlay unread={unread} count={count} dm={dm} />
    </Box>
  );
}
